import React from 'react';
import { translateText } from '../../../helpers/LanguageHelper';
import { TabContent, TabPane, Row, Col } from 'reactstrap';
import ProductBox from './ProductBox';
import Skeleton from './Skeleton/Skeleton';
import CatalogStatus from './CatalogStatus';
import useHomeCatalog from '../../../helpers/useHomeCatalog';

const NewProducts = ({ effect }) => {
    const { products: ProductsList, loading: productsLoading, error, retry } = useHomeCatalog();
    return (
        <>

            <section className="section-pt-space ukl-new-products-tabs">
                <div className="tab-product-main">
                    <div className="tab-prodcut-contain">
                        <div className="ukl-our-products-title">
                            <span className="ukl-our-products-title__icon"><i className="fa fa-shopping-basket" /></span>
                            <div>
                                <h2>{translateText("Our Products")}</h2>
                                <p>{translateText("Fresh Uthukuli favourites, selected for you")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-py-space ratio_asos product ukl-new-products-grid">
                <div className="custom-container">
                    <Row>
                        <Col className="pe-0">
                            <TabContent activeTab="products">
                                <TabPane tabId="products">

                                    <CatalogStatus error={error} loading={productsLoading} count={ProductsList.length} retry={retry} />
                                    {productsLoading && ProductsList.length === 0 ? (
                                        <Skeleton />
                                    ) : ProductsList.length === 0 ? (
                                        <p className="text-center">{translateText(error ? "" : "No products available")}</p>
                                    ) : (
                                        <>
                                            <div className="product product-grid-vertical product-m">
                                                <Row className="ukl-product-row">
                                                    {ProductsList && ProductsList.map((itm, i) => (
                                                        <Col xs="6" md="4" lg="3" xl="3" key={itm.ProductId} className="ukl-product-column">
                                                            <ProductBox
                                                                hoverEffect={effect}
                                                                item={itm}
                                                                layout=""
                                                                ProductDetailPageForceUpload={false}
                                                                fitImage={true}
                                                                priority={i < 4}
                                                            />
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        </>
                                    )}

                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    );
};

export default NewProducts;
